import {
  useEffect,
  useState,
  useRef,
  useCallback,
  useLayoutEffect,
} from 'react';
import axiosInstance from 'src/axios-instance';
import axios from 'axios';
import { condition } from '../utils/logic.utils';

// fires callback when you click outside all objects in list of refs
export const useOnClickOutside = (callback, refs) => {
  const listener = useCallback(
    (event) => {
      const forAny = (fn) => (Array.isArray(refs)
        ? refs.reduce(
          (bool, ref) => !!(bool || (ref && ref.current && fn(ref.current))),
          false,
        )
        : refs && refs.current && fn(refs.current));
      if (
        !forAny((current) => current.contains(event.target))
      ) {
        callback(event);
      }
    },
    [callback, refs],
  );

  useEffect(() => {
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [listener]);
};

// axios request to be made on render
// optional param conditional used to specify whether request should be made, can be function or bool
// Usage: const { data, loading, error } = useAxiosRequest({ url: ... })
export const useAxiosRequest = (request, conditional) => {
  const [data, setData] = useState({});
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof conditional === 'undefined' || condition(conditional)) {
      let unmounted = false;
      const source = axios.CancelToken.source();
      setLoading(true);
      axiosInstance
        .request(request)
        .then((a) => {
          if (!unmounted) {
            setData(a.data);
            setLoading(false);
          }
        })
        .catch((error) => {
          if (!unmounted) {
            setError(error);
            setLoading(false);
          }
        });
      return () => {
        unmounted = true;
        source.cancel();
      };
    }
    return undefined;
  }, [conditional, request]);

  return { data, loading, error };
};
